import React, { useState, useEffect } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Link, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const CourseMasterForm = () => {
  const { id } = useParams();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading(`${!id? "Add":"Edit"} Course Master`))
  }, [])

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    IsInActive: 0,
    lines: [{ Version: "", Remark: "" }],
  };

  const [formData, setFormData] = useState(initialFormData);

  const fetchCourseData = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}course-masters/${id}`);
      if (response.status === 200) {
        const { Code, Name, Description, IsInActive } =
          response?.data?.data?.course || {};
        const courseVersion = response?.data?.data?.courseversion || [];

        const isInActiveValue = IsInActive === 1;

        const lines = courseVersion.map((version) => {
          return {
            ID: version.ID,
            CourseID: version.CourseID,
            Version: version.Version || "",
            IsInActive: isInActiveValue,
            Remark: version.Remark || "",
          };
        });

        setFormData({
          Code,
          Name,
          Description,
          IsInActive: IsInActive === 1 ? 1 : 0,
          lines,
        });
      } else {
        console.error(
          "Failed to fetch course details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchCourseData(id);
    }
  }, [id]);

  const handleChange = (e, index) => {
    const { name, type, checked, value } = e.target;
    const updatedLines = [...formData.lines];
    const newValue = type === "checkbox" ? checked : value;

    updatedLines[index][name] = newValue;
    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));

    // Clear the specific error for the field being edited
    if (name === "Version" && errors.Version) {
      const newErrors = { ...errors };
      delete newErrors.Version;
      setErrors(newErrors);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear the specific error for the field being edited
    if (errors[name]) {
      const newErrors = { ...errors };
      delete newErrors[name];
      setErrors(newErrors);
    }
  };

  const handleDeleteLine = (index) => {
    setDeleteIndex(index);
    setShowModal(true);
  };
  const confirmDeleteLine = async () => {
    const lineToDelete = formData.lines[deleteIndex];

    if (lineToDelete.ID) {
      try {
        const response = await PostServiceCaller(
          `${API_URL}course-masters/${lineToDelete.ID}`,
          formData,
          "delete"
        );

        if (response.status === 200) {
          const updatedLines = formData.lines.filter((_, i) => i !== deleteIndex);
          setFormData((prevState) => ({
            ...prevState,
            lines: updatedLines,
          }));
          toast.success("Version Row deleted successfully!");
        } else {
          throw new Error("Failed to delete the line");
        }
      } catch (error) {
        console.error("There was a problem with the delete operation:", error);
      }
    } else {
      const updatedLines = formData.lines.filter((_, i) => i !== deleteIndex);
      setFormData((prevState) => ({
        ...prevState,
        lines: updatedLines,
      }));
      toast.success("Version Row deleted successfully!");
    }
    setShowModal(false);
    setDeleteIndex(null);
  };

  const handleAddLine = () => {
    const currentRow = formData.lines[formData.lines.length - 1];
    if (currentRow.Version === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    setFormData((prevState) => ({
      ...prevState,
      lines: [...prevState.lines, { Version: "", Remark: "" }],
    }));
  };

  const handleCancel = () => {
    navigate("/course-master");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.Name) newErrors.Name = "Course Name is required";
    formData.lines.forEach((line, index) => {
      if (!line.Version) {
        newErrors.Version = "Course Version is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        let response;
        if (id) {
          response = await PostServiceCaller(
            `${API_URL}course-masters/${id}`,
            formData,
            "put"
          );
        } else {
          response = await PostServiceCaller(
            `${API_URL}course-masters`,
            formData,
            "post"
          );
        }

        if (response.status === 200) {
          toast.success("Data submitted successfully");
          setFormData(initialFormData);
          setTimeout(() => {
            window.location.href = "/course-master";
          }, 2000);
        } else {
          console.error(
            "Failed to submit data. Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data);
        }
      } catch (error) {
        console.error("Error while submitting data:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          if (error.response) {
            console.error(
              "Server responded with status:",
              error.response.status
            );
            console.error("Response data:", error.response.data);
          }
        }
      }
    }
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <ToastContainer />
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-12 col-xl-5">
                  <div className="row">
                    <div className="col-4">
                      <div class="mb-3">
                        <label for="Name" class="form-label">
                          Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Code"
                          aria-describedby="Code"
                          name="Code"
                          placeholder="Code"
                          value={formData.Code}
                          disabled
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-8">
                      <div class="mb-3">
                        <label for="Name" class="form-label">
                          Course Name<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.Name ? "is-invalid" : ""
                            }`}
                          id="Name"
                          aria-describedby="Name"
                          name="Name"
                          placeholder="Course Name"
                          value={formData.Name}
                          onChange={handleInputChange}
                        />
                        {errors.Name && (
                          <div className="invalid-feedback">
                            {errors.Name}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div class="mb-3">
                      <label for="Description" class="form-label">
                        Description
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="Description"
                        aria-describedby="Description"
                        name="Description"
                        placeholder="Description"
                        value={formData.Description}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="d-flex gap-2">
                    <div>
                      <label
                        htmlFor="flexSwitchCheckChecked"
                        className="form-label"
                      >
                        Active
                      </label>
                    </div>
                    <div className="">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="IsInActive"
                        id="flexSwitchCheckChecked"
                        checked={formData.IsInActive === 1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            IsInActive: e.target.checked ? 1 : 0,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-7 p-0">
                  <div className="container-fluid">
                    <div className="table-responsive poc-head rounded">
                      <h5>
                        <b>Course Version Details</b>
                      </h5>
                      <table
                        id="poctable_head"
                        className="table table-bordered"
                      >
                        <thead className="text-center">
                          <tr>
                            <th>Sr. No.</th>
                            <th>
                              Version<span className="required">*</span>
                            </th>
                            <th>Remark</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="text-center">
                          {formData.lines.map((line, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  name="Version"
                                  className={`form-control ${errors.Version ? "is-invalid" : ""
                                    }`}
                                  value={line.Version}
                                  onChange={(e) => handleChange(e, index)}
                                  style={{ width: "100%" }}
                                />
                                {errors.Version && (
                                  <div className="invalid-feedback">
                                    {errors.Version}
                                  </div>
                                )}
                              </td>
                              <td>
                                <input
                                  type="text"
                                  name="Remark"
                                  className="form-control"
                                  value={line.Remark}
                                  onChange={(e) => handleChange(e, index)}
                                  style={{ width: "100%" }}
                                />
                              </td>
                              <td>
                                <div
                                  type="button"
                                  onClick={() => handleDeleteLine(index)}
                                >
                                  <i
                                    className="bi bi-trash"
                                    style={{ fontSize: "1.2rem" }}
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <button
                        type="button"
                        className="custom-btn mb-2"
                        onClick={handleAddLine}
                      >
                        <i className="fa fa-plus"></i> Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-end">
                <button onClick={handleCancel} className="cancel-btn me-2">
                  Cancel
                </button>
                <button type="submit" className="custom-btn">
                Submit
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
   <Modal show={showModal} onHide={() => setShowModal(false)} centered>
  <div className="card rounded-3 border-0" style={{ 
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    border: 'none',
    overflow: 'hidden'
  }}>
    <Modal.Header className="border-0 pb-0" style={{ backgroundColor: '#f8fafc' }}>
      <Modal.Title className="w-100 text-center">
        <div className="d-flex flex-column align-items-center">
   <div
                style={{
                  width: "44px",
                  height: "44px",
                  backgroundColor: "#fee2e2",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "12px",
                  color: "#dc2626",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <i
                  className="bi bi-trash3-fill"
                  style={{
                    fontSize: "22px",
                  }}
                ></i>
              </div>
          <h3 className="m-0" style={{ 
            fontWeight: '600',
            color: '#2E2E48',
            fontSize: '1.25rem'
          }}>
            Delete Confirmation
          </h3>
        </div>
      </Modal.Title>
    </Modal.Header>
    
    <Modal.Body className="text-center py-4" style={{
      backgroundColor: '#ffffff',
      color: '#64748b',
      fontSize: '0.9375rem',
      lineHeight: '1.5'
    }}>
      Are you sure you want to delete this item? This action cannot be undone.
    </Modal.Body>
    
    <Modal.Footer className="border-0 pt-0" style={{ backgroundColor: '#ffffff' }}>
      <div className="d-flex justify-content-center w-100 gap-3">
        <button 
           style={{
                backgroundColor: "#f3f4f6",
                border: "1px solid #e5e7eb",
                padding: "6px 18px",
                borderRadius: "8px",
                fontWeight: "500",
                color: "#374151",
                cursor: "pointer",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
          onClick={() => setShowModal(false)}
        >
          Cancel
        </button>
        <button
              style={{
                backgroundColor: "#27568B",
                border: "none",
                padding: "6px 18px",
                borderRadius: "8px",
                fontWeight: "500",
                color: "#ffffff",
                cursor: "pointer",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
          onClick={confirmDeleteLine}
        >
          Delete
        </button>
      </div>
    </Modal.Footer>
  </div>
</Modal>
    </>
  );
};

export default CourseMasterForm;
